<template>
	<a-result :title="error.statusCode" :status="String(error.statusCode)" :sub-title="error.message">
		<template slot="extra">
			<a key="console" href="/">
				Home page
			</a>
		</template>
	</a-result>
</template>

<script>
	export default {
		name: 'Error',
		//layout: 'blank',
		props: ['error'],
	}
</script>

<style scoped>
	.ant-result {
		padding: 0;
		width: 100%;
		position: absolute;
		top: calc(50% - 220px);
	}
</style>
